/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClusterStateSchema } from './ClusterStateSchema';
import {
    ClusterStateSchemaFromJSON,
    ClusterStateSchemaFromJSONTyped,
    ClusterStateSchemaToJSON,
} from './ClusterStateSchema';

/**
 * 
 * @export
 * @interface ClusterLiteSchema
 */
export interface ClusterLiteSchema {
    /**
     * 
     * @type {number}
     * @memberof ClusterLiteSchema
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof ClusterLiteSchema
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClusterLiteSchema
     */
    updated: Date;
    /**
     * 
     * @type {number}
     * @memberof ClusterLiteSchema
     */
    accountId: number;
    /**
     * 
     * @type {ClusterStateSchema}
     * @memberof ClusterLiteSchema
     */
    currentState: ClusterStateSchema;
    /**
     * 
     * @type {string}
     * @memberof ClusterLiteSchema
     */
    name: string;
}

/**
 * Check if a given object implements the ClusterLiteSchema interface.
 */
export function instanceOfClusterLiteSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;
    isInstance = isInstance && "accountId" in value;
    isInstance = isInstance && "currentState" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function ClusterLiteSchemaFromJSON(json: any): ClusterLiteSchema {
    return ClusterLiteSchemaFromJSONTyped(json, false);
}

export function ClusterLiteSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClusterLiteSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
        'accountId': json['account_id'],
        'currentState': ClusterStateSchemaFromJSON(json['current_state']),
        'name': json['name'],
    };
}

export function ClusterLiteSchemaToJSON(value?: ClusterLiteSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created': (value.created.toISOString()),
        'updated': (value.updated.toISOString()),
        'account_id': value.accountId,
        'current_state': ClusterStateSchemaToJSON(value.currentState),
        'name': value.name,
    };
}

